module.exports = __webpack_public_path__ + "static/media/logo.4f1a7ce4.svg";